import { useContext } from "react"
import { useTranslation } from "react-i18next"

import ContactBanner from "../components/Home/ContactBanner/ContactBanner"
import DataBanner from "../components/Home/DataBanner/DataBanner"
import Header from "../components/Home/Header/Header"
import ImageSlider from "../components/Home/ImageSlider/ImageSlider"
/* import TrustedBanner from "../components/Home/TrustedBanner/TrustedBanner" */
import VideoSlider from "../components/Home/VideoSlider/VideoSlider"
import ChargersMenuSlider from "../components/Home/ChargersMenuSlider/ChargersMenuSlider"
import SectorsMenu from "../components/HomeConfigure/SectorsMenu/SectorsMenu"
import SEO from "../components/SEO/SEO"
import { AppContext } from "../context/AppContext"
import { stripHtml } from "../helpers/general"
import useSiteTitle from "../hooks/use-site-title"

const Home = () => {
  const { t } = useTranslation()

  const { store } = useContext(AppContext)

  const siteTitle = useSiteTitle(false)

  const title = store.initConfig.title

  const metaTitle = stripHtml(t("bienvenido.title", { siteTitle: title }))
  const metaDescription = stripHtml(t("bienvenido.description"))

  return (
    <>
      <SEO
        title={metaTitle}
        description={metaDescription}
        withSuffix={false}
        siteTitle={siteTitle}
      />
      {/* Cabecera de la home */}
      <Header></Header>
      {/* Selector de sector */}
      <SectorsMenu from={"home"}></SectorsMenu>
      {/* Slider imágenes */}
      <ImageSlider></ImageSlider>
      {/* Selector de cargador */}
      <ChargersMenuSlider from={"home"}></ChargersMenuSlider>
      {/* Slider videos */}
      <VideoSlider></VideoSlider>
      {/* Data Banner */}
      <DataBanner></DataBanner>
      {/* Trusted Banner */}
      {/* <TrustedBanner></TrustedBanner>*/}
      {/* Contact Banner */}
      <ContactBanner></ContactBanner>
    </>
  )
}

export default Home
